import { render } from "./Sperrbemerkung.pug?vue&type=template&id=72630a70&lang=pug"
import script from "./Sperrbemerkung.js?vue&type=script&lang=js"
export * from "./Sperrbemerkung.js?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/rel_build_mdm/frontend/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__